import React from 'react';
import PropTypes from 'prop-types';
import OwnerRender from '../../../../components/table-cells/SaleRepsNameRenderer';

function OwnerRenderer(props) {
  const { data, owners, value } = props;
  if (data && owners && owners[data.owner_id]) {
    // if (!value) value = data.first_name + ' ' + data.last_name;
    const owner = owners[data.owner_id];
    return <OwnerRender data={{ owner }} value={value} displayStatus />;
  }
  return null;
}
OwnerRenderer.propTypes = {
  data: PropTypes.shape({
    owner_id: PropTypes.string,
  }),
  value: PropTypes.string,
  owners: PropTypes.shape({}),
};
OwnerRenderer.defaultProps = {
  owners: {},
  data: null,
  value: null,
};
export default OwnerRenderer;
